<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />

  <Dialog header="Legenda" v-model:visible="legendaDialog" :style="{width: '50vw'}">
      <div class="grid">
          <div class="col-6">
            <h6>Legenda Stato Contratti</h6>
            <ul>
              <li v-for="item in legendaStatiContratto" :key="item">{{item.name}} - {{item.value}}</li>
            </ul>
          </div>
          <div class="col-6">
            <h6>Legenda Motivazioni Contratti (ko)</h6>
            <ul>
               <li v-for="item in legendaMotivazioniContrattoKo" :key="item">{{item.name}} - {{item.id}}</li>
            </ul>
          </div>
      </div>
      <template #footer>
          <Button label="Chiudi" icon="pi pi-times" @click="legendaDialog = false" class="p-button-text"/>
      </template>
  </Dialog>

  <div class="page" style="height: 100%; position:relative">
    <Button  @click="legendaDialog = true" icon="pi pi-info" class="mt-3 p-button-rounded p-button-outlined" />
    <div class="mt-4 text-center">
        <div class="button-wrapper mb-2">
          <span class="label" :style="fileXls.length > 0 ? 'background: #4cabf7' : ''">
            {{fileXls.length > 0 ? fileXls[0].name : 'Carica File' }}
          </span>
          <input id="upload" type="file" ref="file" @change="handleFileUpload()" @click="$event.target.value=''" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
        </div>
        <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
        <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>

      <div class="text-center">
        <small>Formati consentiti: {{allowedType.join(", ")}}</small>
      </div>
    </div>

<!-- {{ report }} -->
    <div v-if="report" class="mt-5">
      <Accordion>
        <AccordionTab header="Report">
          <div>
            <h4>Totale inserimenti</h4>
            <p><b>Totale rappresentanti</b>: {{report.total_rapps}}</p>
            <p><b>Totale rappresentanti errori</b>: {{report.total_rapps_error}}</p>
            <p><b>Totale clienti</b>: {{report.total_clients}}</p>
            <p><b>Totale clienti esistenti</b>: {{report.total_clients_existent}}</p>
            <p><b>Totale clienti esistenti (cf/piva)</b>: {{report.total_clients_existent_name.join(', ')}}</p>
            <p><b>Totale clienti errori</b>: {{report.total_clients_error}}</p>
            <p><b>Totale contratti</b>: {{report.total_contracts}}</p>
            <p><b>Totale forniture</b>: {{report.total_pods}}</p>
            <p><b>Totale forniture esistenti</b>: {{report.total_pods_existent}}</p>
            <p><b>Totale forniture esistenti (code)</b>: {{report.total_pods_existent_code.join(', ')}}</p>
            <p><b>Totale forniture aggiornate</b>: {{report.total_pods_updated}}</p>
            <p><b>Totale forniture aggiornate (code)</b>: {{report.total_pods_updated_code.join(', ')}}</p>
          </div>
          <div v-if="Object.keys(report.errors).length > 0" class="mt-5">
            <h4>Errori</h4>
            <DataTable :value="report.errors" responsiveLayout="scroll">
                <Button 
                label="Scarica Massivo" 
                icon="pi pi-download"
                iconPos="right" 
                class="p-button-error mr-3"
                @click="downloadCheckedMassivo($event)" 
                />
              <p v-for="(error, index) in report.errors" :key="index"><b>{{ index }}</b> {{ error }}</p>
            </DataTable>
          </div>
          
        </AccordionTab>
      </Accordion>
    </div>

  </div>
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Preview" 
          icon="pi pi-search"
          iconPos="right" 
          class="p-button-warning mr-3"
          @click="onPreviewButton($event)" 
        />
        <!-- <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          :disabled="disableExecuteButton"
          @click="onCaricaButton($event)" 
        /> -->
        

    </div>
  </div>

</template>

<script>

import { ref, getCurrentInstance, onMounted } from 'vue';
import Service from '@/services/ask-operation/operation-service'
import UtilityService from '@/services/ask-management/utility-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup() {
    const page = { name: 'contratti-vendita-inserimento-massivo-ee'}
    const loader = ref(false)
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const utilityService = new UtilityService(self.$http, self.$eventBus)
    const fileXls = ref([])
    const allowedType = ['xlsx', 'xls']
    const report = ref();
    const path = ref();
    const legendaDialog = ref(false);
    const legendaStatiContratto = ref([])
    const legendaMotivazioniContrattoKo = ref([])
    const validationErrors = ref({})
    const submitted = ref(false)
    const disableExecuteButton = ref(true);


    onMounted(() => {
      geTipiStatoContratto()
      geMotivazioniStatoContrattoKo()
    })
      

    const handleFileUpload = () => {
      fileXls.value = []
      submitted.value = false;
      fileXls.value = self.refs.file.files
    }
      
    const onOkButton = () => {
      report.value = null
      submitted.value = true;
      toast.removeGroup(page.name);
      if (validateForm() ) {
         
        loader.value = true
        service.uploadInserimentoMassivoFile(fileXls.value, 'ee')
        .then((res)=>{
          report.value = res.items
        })
        .catch(() => {
          fileXls.value = []
          loader.value = false
          toast.add({severity:'error', summary: 'Attenzione', detail:'Errore nell \' analisi del file ', group: page.name, life:10000});
        })
        .finally(()=>{
          fileXls.value = []
          loader.value = false
          // self.$eventBus.emit(`dialog-return-ok-button`, {}) 
        })            

      }
    }
    const onCaricaButton = () => {
      report.value = null
      submitted.value = true;
      toast.removeGroup(page.name);
      loader.value = true
      service.uploadMassivo()
      .then((res)=>{
        // toast.add({severity:'success', summary: '', detail:`${res.msg}`, group: page.name});
        report.value = res.msg
      })
      // .catch(() => {
      //   fileXls.value = []
      //   loader.value = false
      //   toast.add({severity:'error', summary: 'Attenzione', detail:'Errore nell \' analisi del file ', group: page.name});
      // })
      .finally(()=>{
        fileXls.value = []
        loader.value = false
        // self.$eventBus.emit(`dialog-return-ok-button`, {}) 
      })
    }


    const onPreviewButton = () => {
      report.value = null
      submitted.value = true;
      toast.removeGroup(page.name);
      if (validateForm() ) { 
        loader.value = true
        service.checkInserimentoFileMassivo(fileXls.value, true, 'ee')
        .then((res)=>{console.log(res);
          // report.value = Object.keys(res.items.errors).length !== 0 ? res.items : null;
          // path.value = report.value ? res.path : null;
          report.value = res.items;
          path.value = Object.keys(res.items.errors).length !== 0 ? res.path : null;
          disableExecuteButton.value = Object.keys(res.items.errors).length !== 0;
        })
        .catch(() => {
          fileXls.value = []
          loader.value = false
          toast.add({severity:'error', summary: 'Attenzione', detail:'Errore nell \' analisi del file ', group: page.name, life:10000});
        })
        .finally(()=>{
          fileXls.value = []
          loader.value = false
          // self.$eventBus.emit(`dialog-return-ok-button`, {}) 
        })            
      }
    }
    const downloadCheckedMassivo = () => {
      loader.value = true
        service.downloadMassivo(path.value)
        .then(()=>{
          report.value = null;
          path.value = null;
          disableExecuteButton.value = true;
        })
        .catch(() => {
          fileXls.value = []
          loader.value = false
        })
        .finally(()=>{
          fileXls.value = []
          loader.value = false
          // self.$eventBus.emit(`dialog-return-ok-button`, {}) 
        })            

    }


    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }


    const geTipiStatoContratto = () => {
      utilityService.geTipiStatoContratto().then((res) => {
        legendaStatiContratto.value = res.items
      })
    }

    const geMotivazioniStatoContrattoKo = () => {
      utilityService.geMotivazioniStatoContrattoKo().then((res) => {
        legendaMotivazioniContrattoKo.value = res.items
      })
    }

    const validateForm = () => {

      if (fileXls.value.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }

      if (fileXls.value.length > 0) {
        let valid = [...fileXls.value].every(file => ['application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(file.type), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      return !Object.keys(validationErrors.value).length;
    }


    return {
      page,
      fileXls,
      allowedType,
      report,
      legendaStatiContratto,
      legendaMotivazioniContrattoKo,
      loader,
      handleFileUpload,
      validationErrors, 
      submitted,
      onOkButton,
      onCaricaButton,
      onPreviewButton,
      onCancelButton,
      downloadCheckedMassivo,
      legendaDialog,
      disableExecuteButton
    }
  }
}


</script>

<style scoped>
.button-wrapper {
  position: relative;
  width: 290px;
  text-align: center;
  padding: 12px 20px;
  display: block;
  margin: auto;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #aaaaaa;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
  -webkit-box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0,0,0,0); 
  box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0,0,0,0);
}

#upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 50px;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
</style>

